import { render, staticRenderFns } from "./AddFansToGroupDialog.vue?vue&type=template&id=67237e11&scoped=true"
import script from "./AddFansToGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddFansToGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./AddFansToGroupDialog.vue?vue&type=style&index=0&id=67237e11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67237e11",
  null
  
)

export default component.exports